import React from 'react';

// Enter and Space activate a control that behaves as a button (WCAG 2.1.1).
export const isActivationKey = (event: React.KeyboardEvent<Element> | KeyboardEvent): boolean =>
  event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar';
